module.exports = "/static/assets/0d9d5b90116fb38324a800a3cbfdd4b8.png";